module.exports = __webpack_public_path__ + "img/materials-light.819dcfad.svg";